// src/pages/account/LoungeTransactionDetails.jsx
import React from 'react';
import TransactionDetails from '../TransactionDetails';

const LoungeTransactionDetails = () => {
  return <TransactionDetails locationKey="lounge" />;
};

export default LoungeTransactionDetails;